module.exports = __webpack_public_path__ + "img/kf_ico.68d5b832.png";